import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface IWordPredictionResponse {
    beginSuggestions: string[];
    generatedSuggestions: string[];
}

@Injectable({
    providedIn: 'root'
})
export class WordPredictionApiService {
    constructor(
        private http: HttpClient,
    ) {
    }

    suggestedWords(word: string, lang: string): Promise<IWordPredictionResponse> {
        return this.http.post(`${environment.conversions.baseUrl}/api/v1/wordprediction`, { word }, {
                headers: {
                    Language: lang
                }
            }).toPromise() as Promise<IWordPredictionResponse>;
    }
}
